
import { defineComponent, PropType } from 'vue'
import { createDuration, DurationTypeT } from '~/utils/date'

export default defineComponent({
  name: 'GraphControl',
  props: {
    filterValue: {
      type: Number,
      default: 30
    },
    allowChartTypeToggle: {
      type: Boolean,
      default: false
    },
    dayOptions: {
      type: Array as PropType<number[]>,
      default: () => [30, 60, 90]
    },
    chartType: {
      type: String,
      default: 'line'
    },
    displayDurationType: {
      type: String as PropType<DurationTypeT>,
      default: DurationTypeT.days
    }
  },
  data() {
    return {
      currentFilterValue: 30,
      currentChartType: 'line'
    }
  },
  computed: {
    displayDayOptions(): number[] {
      return this.dayOptions.map((dayOption: number) =>
        createDuration(dayOption, 'days').as(this.displayDurationType)
      )
    }
  },
  watch: {
    currentFilterValue(newVal: number) {
      this.$emit('updateFilter', Number(newVal))
    }
  },
  created() {
    this.currentFilterValue = this.filterValue
    this.currentChartType = this.chartType
  },
  methods: {
    toggleChart(newVal: string) {
      this.currentChartType = newVal
      this.$emit('updateChartType', newVal)
    }
  }
})
